import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { DestroyRef, Directive, inject, input } from '@angular/core';
import { INVITATION_DELETE_CONFIRMATION_MODAL_DATA } from '@shared/directives/invitations/constants/invitation-modals-data.constants';
import { ConfirmationModalComponent } from '@shared/components/confirmation-modal/confirmation-modal.component';
import { catchError, filter, finalize, of, switchMap, tap } from 'rxjs';
import { ToastService } from '@shared/components/toast';
import {
  InvitationResourceService,
  InvitationHttpService,
  LoaderService,
} from '@shared/services';
import { INVITATION_ACTION_TOASTS } from './constants/invitation-actions-toasts.constant';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: 'icon-button[appDeleteInvitation]',
  host: {
    '(click)': 'openConfirmationModal()',
  },
})
export class DeleteInvitationDirective {
  public invitationId = input.required<number>();
  private readonly _dialog = inject(Dialog);
  private readonly _invitationResourceService = inject(
    InvitationResourceService,
  );
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _invitationHttp = inject(InvitationHttpService);
  private readonly _toast = inject(ToastService);
  private readonly _loaderService = inject(LoaderService);

  private _dialogRef?: DialogRef<unknown, ConfirmationModalComponent>;

  protected openConfirmationModal() {
    this._dialogRef = this._dialog.open(ConfirmationModalComponent, {
      data: INVITATION_DELETE_CONFIRMATION_MODAL_DATA,
    });

    this._observeDialogClose();
  }

  private _observeDialogClose() {
    this._dialogRef?.closed
      .pipe(
        filter((confirmed) => confirmed === true),
        tap(() => this._loaderService.show()),
        switchMap(() => this._deleteInvitedSubscriber()),
        catchError(() => {
          this._toast.show(INVITATION_ACTION_TOASTS['deleteError']);
          return of(null);
        }),
        tap(() => {
          this._toast.show(INVITATION_ACTION_TOASTS['deleteSuccess']);
          this._invitationResourceService.resetResource();
        }),
        finalize(() => this._loaderService.hide()),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe();
  }

  private _deleteInvitedSubscriber() {
    return this._invitationHttp.deleteInvitation(this.invitationId());
  }
}
